/* eslint-disable jsx-a11y/label-has-associated-control */
import cx from 'classnames';
import _ from 'lodash';
import React from 'react';
import { getOnEnter } from '../_utils';
import { Typography } from '../typography';
import styles from './toggle.module.scss';
export const Toggle = ({ label, className, onChange, hideLabel = false, checked = false, disabled = false, name = '', configLabel, labelPosition = 'left', disabledTooltipContent = '', tooltipPosition = 'top', noMargin = false, noLeftMargin = false, ...restProps }) => {
    const containerClassNames = cx(className, styles.toggleSwitch, {
        [styles.disabled]: disabled,
    });
    const labelClassNames = cx(styles.label, {
        [styles.labelPositionRight]: labelPosition === 'right' && !hideLabel,
        [styles.noBottomMargin]: noMargin,
        [styles.noLeftMargin]: noLeftMargin,
    });
    const handleChange = (event) => {
        if (onChange) {
            onChange(event);
        }
    };
    const labelProps = {
        className: labelClassNames,
        htmlFor: hideLabel || !name ? undefined : `form-item-${name}`,
    };
    let ariaLabel;
    if (!hideLabel) {
        if (_.isString(configLabel)) {
            ariaLabel = configLabel;
        }
        else if (_.isString(label)) {
            ariaLabel = label;
        }
    }
    return (React.createElement("div", { className: containerClassNames, "data-tooltip-content": disabledTooltipContent, "data-tooltip-position": tooltipPosition, ...restProps },
        React.createElement("label", { ...labelProps },
            !hideLabel && (React.createElement(Typography, { variant: "body-normal", className: styles.toggleSwitchTitle, overrideTag: "span" }, label)),
            React.createElement("input", { type: "checkbox", className: styles.toggleCheckbox, "aria-label": ariaLabel, id: `form-item-${name}`, role: "switch", disabled: disabled, onKeyDown: getOnEnter(handleChange), onChange: handleChange, "aria-checked": checked, checked: checked }),
            React.createElement("div", { className: styles.toggleSwitchBackground },
                React.createElement("div", { className: styles.toggleSwitchMarker })))));
};
//# sourceMappingURL=toggle.js.map